"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const storage_1 = require("./storage");
const store = new storage_1.LocalStorage('spacex');
const SCENE_ID = 12; // 场景ID, CMS固定值
// 从spacex平台获取slotid
function getAbSlotid(key, callback) {
    const storeKey = store.getItem(`ad/${key}`);
    const storeTime = store.getItem(`ad/update_time`) || Date.now();
    let hasCallback = false;
    function cb(value) {
        store.setItem(`ad/${key}`, value || '');
        store.setItem(`ad/update_time`, Date.now());
        if (!hasCallback) {
            hasCallback = true;
            callback(value);
        }
    }
    if (!key) {
        return callback('');
    }
    // 一个小时之内 则直接返回缓存值
    if (storeKey && Date.now() - storeTime < 3600000) {
        cb(storeKey);
    }
    if (window.ucapi && window.ucapi.invoke) {
        window.ucapi.invoke('spacex.getExpsParamForSceneId', {
            sceneId: SCENE_ID,
            success(data) {
                let expsParam = {};
                const adMap = {};
                if (data && data.expsParam) {
                    expsParam = mapToJson(data.expsParam);
                }
                console.log('实验平台返回数据', expsParam);
                if (expsParam && expsParam.iflow_ad_slotid) {
                    const array = expsParam.iflow_ad_slotid.split(';');
                    for (let i = 0; i < array.length; i++) {
                        const n = array[i].split(':');
                        adMap[n[0]] = n[1];
                    }
                }
                else {
                    cb('');
                }
                cb(adMap[key]);
            },
            fail() {
                cb('');
            },
        });
    }
    else {
        cb('');
    }
}
exports.getAbSlotid = getAbSlotid;
function mapToJson(str) {
    if (!str || str === '{}') {
        return {};
    }
    str = str.substring(1, str.length - 1);
    const array = str.split(', ');
    const map = {};
    for (let i = 0; i < array.length; i++) {
        const tmp = array[i].match(/([^=]*)=(.*)/);
        if (tmp) {
            map[tmp[1]] = tmp[2];
        }
    }
    return map;
}
//# sourceMappingURL=data:application/json;base64,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